/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalComments
 */
export interface AdditionalComments {
}

/**
 * Check if a given object implements the AdditionalComments interface.
 */
export function instanceOfAdditionalComments(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdditionalCommentsFromJSON(json: any): AdditionalComments {
    return AdditionalCommentsFromJSONTyped(json, false);
}

export function AdditionalCommentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalComments {
    return json;
}

export function AdditionalCommentsToJSON(value?: AdditionalComments | null): any {
    return value;
}

